module.exports = __webpack_public_path__ + "media/src/img/payment/qw-ec83ac34a9ee6f927833296dd1d914ed.png";